<template>
  <v-btn fab x-small to="/">
    <v-icon>mdi-home-outline</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: "XsHomeButton",
};
</script>
